let Slider;
export default () => ({
	createSlider() {
		Slider = new window.Swiper('.instafeed__slider', {
			slidesPerView: 1.4,
			speed: 500,
			freeMode: true,
			spaceBetween: 16,
			breakpoints: {
				480: {
					slidesPerView: 1.85,
				},
				768: {
					slidesPerView: 2.75,
				},
				1024: {
					spaceBetween: 32,
					slidesPerView: 3.85,
				},
				1440: {
					slidesPerView: 4.65,
				},
			},
			navigation: {
				nextEl: '.instafeed__next-slide',
				prevEl: '.instafeed__prev-slide',
			},
		});
	},

	init() {
		this.createSlider();
	},
});
